/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { Circle, Path, Svg } from 'react-native-svg'

export const InfoAirportSpecific: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <Circle cx='12' cy='12' r='10' fill='#FF8B1F' />
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.6667 14.4599L13.0367 12.7099V16.5633L14.4526 17.6234V18.6666L11.9916 17.9767L9.54745 18.6666V17.6234L10.9297 16.5633V12.7099L5.33337 14.4599V13.0801L10.9297 9.56326V5.7099C10.9297 5.41823 11.0308 5.17143 11.2331 4.96951C11.4354 4.76759 11.6882 4.66663 11.9916 4.66663C12.295 4.66663 12.5451 4.76759 12.7417 4.96951C12.9384 5.17143 13.0367 5.41823 13.0367 5.7099V9.56326L18.6667 13.0801V14.4599Z'
            fill='#2B2B2B'
        />
    </Svg>
)
